export default "__VITE_ASSET__C6dE2FGE__"